import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ImageFromClipboardEventService {

  constructor() { }

  // I return the first Image File from the given paste event (or null).
  getPastedImages( event: ClipboardEvent ): File[] | null {

    // NOTE: I am not very familiar with the Paste Event. As such, I am probably
    // being more cautious here than I need to be. However, in an abundance of
    // caution, I am checking each part of the targeted object path.

    if (  !event.clipboardData ||  !event.clipboardData.files ||
          !event.clipboardData.files.length) {
        return null;
    }

    const files: File[] = [];

    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < event.clipboardData.files.length; i++) {
      if ( this.isImageFile( event.clipboardData.files[ i ] ) ) {
        files.push( event.clipboardData.files[ i ] );
      }
    }

    return files;
  }

  // I determine if the given File is an Image (according do its Mime-Type).
  isImageFile( file: File ): boolean {
  return( file.type.search( /^image\//i ) === 0 );
  }
}
